import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./StoryScreen2.css"
import { ImgStoryScreen2, ImgStoryScreen2b, ImgStoryScreen2c } from "../../assets";

const StoryScreen2 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenStoryScreen2 = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenStoryScreen2.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenStoryScreen2: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenStoryScreen2: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {
            left: {
                desc: 
                // [
                //     "It all started with a question “why is plant-based food made to be trendy and expensive?” As Indonesians who grew up eating various Indonesian food that many are plant-based such as jackfruit rind curry from West Sumatra, tofu, the nationally beloved tempeh,  mandai — indigenous southern Kalimantan fermented jackfruit rind, I find this question tugging me the moment I set afoot in Europe. I found plant-based food made to be a lifestyle in Europe that is not accessible for all. I mean not the real plant-protein rich diets that has been practiced for so long in Asia, but many plant-based and vegan products and restaurants that exist in Europe.",
                //     "Then, 1 year into living in Sweden, I started to miss tempe so much I was thinking maybe by luck I can find it in the market. Then I found 2 food brands in Sweden that sells tempe and sell it as completely other name than tempe, making it as if they are very innovative vegan brands that come up with tempe fermentation. (I mean imagine taking Kombucha, Wine, or Kimchi and obliterate the whole entire history of the food and heritage and call it other name)."
                // ]
                [
                    "Hej, I’m Aisya. I’ve been working in the food space for over seven years—exploring fermentation, product development, food technology, and flavor design. One of my favorite foods is tempeh which I usually enjoyed with sambal."
                ]
            },
            right: {
                image: {
                    src: ImgStoryScreen2c,
                    alt: ""
                }
            }
        }
    }
    
    return(
        <>
            <div 
            ref={screenStoryScreen2} 
            className={`${windowWidthClass}-story-screen-2 wrapper`}>

                <div className="background">
                    <div className="frame">
                        {/* <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        /> */}
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="text-wrapper left">
                           {componentData.content.left.desc.map((text:any, index:any)=>{
                            return (
                                <h2 key={index}>{text}</h2>
                            )
                           })}
                    </div>
                    <div className="text-wrapper right image">
                        <div className="frame">
                            <img 
                                alt=""
                                src={componentData.content.right.image.src}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default StoryScreen2;